import { getStore } from '../store/store';
import getTabIdFromWindow from '../utils/getTabIdFromWindow';
import { DEFAULT_DRAWER_PANE_WIDTH } from '../constants/constants';

/**
 * Returns the current width for the specified pane in the given window.
 * If the pane has no store entry, returns DEFAULT_DRAWER_PANE_WIDTH.
 *
 * @param paneId - The unique identifier for the drawer pane.
 * @param targetWindow - The window context to look up the pane state (defaults to current window).
 * @returns The width of the drawer pane in pixels.
 */
export function getDrawerPaneWidth(paneId?: string, targetWindow?: Window): number {
    if (paneId) {
        const tabId = getTabIdFromWindow(targetWindow);
        const state = getStore().paneStateMap.get(tabId)?.get(paneId);

        if (state) {
            return state.currentWidth;
        }
    }

    return DEFAULT_DRAWER_PANE_WIDTH;
}
